export default __webpack_public_path__ + "static/media/table.5446be1f.jpg";